<template>
    <el-dialog
        class="msg-dialog"
        title="详情"
        :visible.sync="visible"
        :append-to-body="true"
    >
        <div v-if="data">
            <div v-if="data.messageType !== undefined">
                <div class="content">
                    <div v-html="data.content"></div>
                    <!-- <a v-if="data.url" href="javascript:;" class="checkbtn" @click="handleDownload">查看附件</a> -->
                </div>
            </div>
            <div v-else>
                <h1 class="title">{{ data.title }}</h1>
                <div class="time">{{ data.applicationName }}  {{ data.createTime }}</div>
                <div class="content" v-html="data.content"></div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        data: {
            default() {
                return {};
            }
        }
    },
    data: function() {
        return {
            visible: false
        };
    },
    methods: {
        handleVisible(flag = false) {
            this.visible = flag;
        },
        handleDownload() {
            window.open(this.data.url);
        }
    }
};
</script>
<style lang="less">
    .msg-dialog {
        line-height: initial;
        .el-dialog {
            min-height: 435px;
        }
        i.el-icon-close {
            width: auto;
            height: auto;
            line-height: initial;
            border-radius: 0;
            &:hover {
                background-color: transparent;
                color: #898C8C;
            }
            &:before {
                display: initial;
                text-align: center;
                font-size: initial;
            }
        }
        .el-dialog__body {
            padding: 20px;
            min-height: 380px;
            max-height: 480px;
            overflow-y: auto;
            box-sizing: border-box;
            .title {
                font-size: 16px;
                color: #252626;
                margin-top: 0;
                margin-bottom: 11px;
            }
            .time {
                font-size: 12px;
                color: #898C8C;
                margin-bottom: 20px;
            }
            .content {
                font-size: 12px;
                line-height: 26px;
            }
            .checkbtn {
                color: #00BCBF;
            }
        }
    }
</style>
